import { Avatar, Box, Typography } from "@mui/material"
import { styled } from "@mui/system"
import dompurify from "dompurify"
import AdminUser from "models/convention-api/v1/AdminUser"
import React from "react"
import { nameToInitials } from "utils/helpers"

interface SessionSpeakerCardProps {
  adminUser: AdminUser
  className?: string
}

const SessionSpeakerCard = (props: SessionSpeakerCardProps) => {
  const { adminUser, className } = props
  const name = `${adminUser.first_name} ${adminUser.last_name}`

  return (
    <_RootContainer className={className}>
      <_TopContainer>
        <_Avatar src={adminUser.avatar.thumb_url} children={nameToInitials(name)} />
        <_TextContainer>
          <_Name>{name}</_Name>
          <_Role>{adminUser.title}</_Role>
        </_TextContainer>
      </_TopContainer>
      <_Bio dangerouslySetInnerHTML={{ __html: dompurify.sanitize(adminUser.bio) }}></_Bio>
    </_RootContainer>
  )
}

export default SessionSpeakerCard

const _RootContainer = styled(Box)({
  display: "flex",
  flexFlow: "column nowrap",
  width: "100%",
})

const _TopContainer = styled(Box)({
  display: "flex",
  flexFlow: "row nowrap",
  alignItems: "center",
  width: "100%",
})

const _Avatar = styled(Avatar)(({ theme }) => ({
  width: 50,
  height: 50,
  backgroundColor: theme.palette.primary.main,
})) as typeof Avatar

const _TextContainer = styled(Box)({
  flexGrow: "1",
  marginLeft: "15px",
})

const _Name = styled(Typography)(({ theme }) => ({
  ...theme.fonts.raleway700,
  fontSize: "18px",
  lineHeight: "21px",
})) as typeof Typography

const _Role = styled(Typography)(({ theme }) => ({
  ...theme.fonts.lato400,
  fontSize: "14px",
  lineHeight: "17px",
})) as typeof Typography

const _Bio = styled(Typography)(({ theme }) => ({
  maxWidth: "650px",
  marginTop: "10px",
  ...theme.fonts.lato400,
  fontSize: "16px",
  lineHeight: "22px",
})) as typeof Typography
